module.exports = __webpack_public_path__ + "static/media/Popup-yritys.e2f8c2bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logos/screenCaptures/Popup-yritys.png
// module id = 1433
// module chunks = 0